module.exports = __webpack_public_path__ + "static/media/openflowFirst@3x.7e756564.png";